import { render, staticRenderFns } from "./ProfileBankPayment.vue?vue&type=template&id=6247ef7d"
import script from "./ProfileBankPayment.vue?vue&type=script&lang=js"
export * from "./ProfileBankPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports